export const TYPES = {
  SET_CLIENT_SUCCESS: "client/SET_CLIENT_SUCCESS",
};
